import axios from "axios";
import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

const DEVICE_KEY = "jt_device_id";
export const deviceId = () => {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) { id = crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`; localStorage.setItem(DEVICE_KEY, id); }
    return id;
  } catch (e) { return ""; }
};
api.interceptors.request.use((cfg) => { const id = deviceId(); if (id) cfg.headers["X-Device-Id"] = id; return cfg; });

// On a 401 (expired access token), try a single silent refresh then retry once.
let refreshing = null;
let toldSignedOut = false;
const signedOutHere = (error) => {
  if (toldSignedOut || error.response?.data?.detail !== "This device was signed out") return;
  toldSignedOut = true;
  toast.info("You've been signed out here because your account was signed in on another device. Your progress is saved to your account — log in again to continue on this device.", { duration: 10000 });
};
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    signedOutHere(error);
    const skip = url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/refresh") || url.includes("/auth/me");
    if (status === 401 && original && !original._retry && !skip) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadWorksheet(n, sheet = "worksheet") {
  const win = window.open("", "_blank");
  if (win) win.document.write("<p style=\"font-family:sans-serif;padding:24px\">Opening your worksheet…</p>");
  try {
    const res = await api.get(`/worksheets/${n}?sheet=${sheet}`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    if (win) win.location.href = url;
    else {
      const a = document.createElement("a");
      a.href = url; a.download = `jt-hub-lesson${n}-${sheet}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return true;
  } catch (e) {
    const page = `${BASE}/api/worksheets/${n}?sheet=${sheet}`;
    if (win) win.location.href = page;
    else if (e.response?.status === 403) window.location.href = page;
    return false;
  }
}
